(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["npr-announcement-bar"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-npr-ann]').forEach(function(v){
    var msgs=v.querySelectorAll('[data-npr-ann-msg]'); if(msgs.length<2)return;
    var i=0, ms=parseInt(v.dataset.autoplay,10);
    if(!ms)return;
    setInterval(function(){ msgs[i].classList.remove('is-active'); i=(i+1)%msgs.length; msgs[i].classList.add('is-active'); }, ms);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["npr-faq"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('.npr-faq [data-npr-faqtabs]').forEach(function(tabs){
      var sec=tabs.closest('.npr-faq');
      tabs.querySelectorAll('[data-npr-faqtab]').forEach(function(tab){
        tab.addEventListener('click',function(){
          var cat=tab.getAttribute('data-npr-faqtab');
          tabs.querySelectorAll('[data-npr-faqtab]').forEach(function(t){var on=t===tab;t.classList.toggle('is-active',on);t.setAttribute('aria-selected',on);});
          sec.querySelectorAll('[data-npr-faqcat]').forEach(function(it){var show=it.getAttribute('data-npr-faqcat')===cat;it.hidden=!show;if(!show)it.open=false;});
        });
      });
    });
  })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["npr-product-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-npr-gallery]').forEach(function (g) {
      var slides = g.querySelectorAll('[data-npr-slide]');
      var thumbs = g.querySelectorAll('[data-npr-thumb]');
      var current = 0;
      function show(i) {
        current = i;
        slides.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
        thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); t.setAttribute('aria-selected', n === i); });
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { show(parseInt(t.dataset.nprThumb, 10)); }); });
      function go(delta) { var n = slides.length; if (!n) return; show((current + delta + n) % n); }
      var navPrev = g.querySelector('[data-npr-prev]');
      var navNext = g.querySelector('[data-npr-next]');
      if (navPrev) navPrev.addEventListener('click', function (e) { e.stopPropagation(); go(-1); });
      if (navNext) navNext.addEventListener('click', function (e) { e.stopPropagation(); go(1); });

      // Lightbox
      var section = g.closest('.npr-hero-section');
      var box = section && section.querySelector('[data-npr-lightbox]');
      var boxImg = box && box.querySelector('[data-npr-lightbox-img]');
      var stage = g.querySelector('[data-npr-gallery-stage]');
      function openBox() {
        if (!box || !boxImg) return;
        var active = g.querySelector('.npr-gallery__slide.is-active .npr-gallery__img');
        if (!active) return;
        boxImg.src = active.getAttribute('data-npr-full') || active.currentSrc || active.src;
        box.hidden = false;
        document.body.style.overflow = 'hidden';
        var close = box.querySelector('[data-npr-lightbox-close]');
        if (close) close.focus();
      }
      function closeBox() { if (!box) return; box.hidden = true; document.body.style.overflow = ''; }
      if (stage) {
        stage.addEventListener('click', openBox);
        stage.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openBox(); } else if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); } else if (e.key === 'ArrowRight') { e.preventDefault(); go(1); } });
      }
      if (box) {
        box.addEventListener('click', function (e) { if (e.target === box || e.target.hasAttribute('data-npr-lightbox-close')) closeBox(); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !box.hidden) closeBox(); });
      }
    });
  })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["npr-sticky-atc"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-npr-sticky]').forEach(function(bar){
    var after=parseInt(bar.dataset.showAfter,10)||600;
    function onScroll(){var y=window.scrollY||document.documentElement.scrollTop;var show=y>after;bar.classList.toggle('is-visible',show);bar.setAttribute('aria-hidden',show?'false':'true');}
    window.addEventListener('scroll',onScroll,{passive:true}); onScroll();
    // Reserve space below the page content so the fixed bar never covers the footer.
    // A spacer placed right after the footer lives in the scroll flow, so it works whether
    // the page scrolls on <html>/window or on an inner scroll container.
    function reserve(){
      var shown = window.getComputedStyle(bar).display !== 'none';
      var h = shown ? bar.offsetHeight : 0;
      var sp = document.getElementById('npr-sticky-spacer');
      if(h<=0){ if(sp){ sp.style.height='0px'; } return; }
      if(!sp){
        sp=document.createElement('div');
        sp.id='npr-sticky-spacer';
        sp.setAttribute('aria-hidden','true');
        sp.style.width='100%';
        sp.style.flex='0 0 auto';
        sp.style.pointerEvents='none';
        var fs=document.querySelectorAll('footer');
        var f=fs[fs.length-1];
        if(f && f.parentNode){ f.parentNode.insertBefore(sp, f.nextSibling); }
        else { document.body.appendChild(sp); }
      }
      sp.style.height=h+'px';
    }
    reserve();
    window.addEventListener('resize', reserve, {passive:true});
    window.addEventListener('load', reserve);
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(reserve); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
